import { v4 } from '@lukeed/uuid';
import { toScaleRatio } from '../../helper/Zoom1DManager';
import { getMatrixGenerationDefaultOptions } from '../panelsPreferencesDefaultValues';
import { getActiveWorkspace } from '../utilities/getActiveWorkspace';
function getMatrixGenerationPanelOptions(draft, nucleus) {
    initMatrixGeneration(draft, nucleus);
    const currentWorkspacePreferences = getActiveWorkspace(draft);
    const panels = currentWorkspacePreferences.panels;
    const matrixGeneration = panels.matrixGeneration?.[nucleus];
    return matrixGeneration;
}
function initMatrixGeneration(draft, nucleus) {
    const currentWorkspacePreferences = getActiveWorkspace(draft);
    const panels = currentWorkspacePreferences.panels;
    if (!panels.matrixGeneration?.[nucleus]) {
        const options = getMatrixGenerationDefaultOptions();
        panels.matrixGeneration = {
            ...panels.matrixGeneration,
            [nucleus]: options,
        };
    }
    return panels.matrixGeneration;
}
function addExclusionZone(draft, action) {
    const { zone, range, nucleus } = action.payload;
    const matrixGeneration = getMatrixGenerationPanelOptions(draft, nucleus);
    if (!matrixGeneration)
        return;
    const exclusionZone = {
        id: v4(),
        ...zone,
    };
    matrixGeneration.matrixOptions.range = range;
    matrixGeneration.matrixOptions.exclusionsZones.push(exclusionZone);
}
function deleteExclusionZone(draft, action) {
    const { zone, nucleus } = action.payload;
    const matrixGeneration = getMatrixGenerationPanelOptions(draft, nucleus);
    if (!matrixGeneration)
        return;
    const options = matrixGeneration.matrixOptions;
    options.exclusionsZones = options.exclusionsZones.filter((_zone) => _zone.id !== zone.id);
}
function setMatrixGenerationOptions(draft, action) {
    const { options, nucleus } = action.payload;
    const matrixGeneration = getMatrixGenerationPanelOptions(draft, nucleus);
    matrixGeneration.matrixOptions = options;
}
function toggleMatrixGenerationViewProperty(draft, action) {
    const { key, nucleus } = action.payload;
    const matrixGeneration = getMatrixGenerationPanelOptions(draft, nucleus);
    if (!matrixGeneration)
        return;
    matrixGeneration[key] = !matrixGeneration[key];
}
function resetDefaultViewMatrixGenerationOptions(draft, action) {
    const { nucleus } = action.payload;
    const matrixGeneration = initMatrixGeneration(draft, nucleus);
    const currentOptions = getMatrixGenerationPanelOptions(draft, nucleus);
    const { matrixOptions } = currentOptions;
    const { matrixOptions: defaultMatrixOptions, ...vewOptions } = getMatrixGenerationDefaultOptions();
    matrixGeneration[nucleus] = { matrixOptions, ...vewOptions };
}
function changeMatrixGenerationScale(draft, action) {
    const { zoomOptions, nucleus } = action.payload;
    const matrixGeneration = getMatrixGenerationPanelOptions(draft, nucleus);
    if (!matrixGeneration)
        return;
    const scaleRatio = toScaleRatio(zoomOptions);
    matrixGeneration.scaleRatio *= scaleRatio;
}
function changeMatrixGenerationStocsyChemicalShift(draft, action) {
    const { chemicalShift, nucleus } = action.payload;
    const matrixGeneration = getMatrixGenerationPanelOptions(draft, nucleus);
    if (!matrixGeneration)
        return null;
    matrixGeneration.chemicalShift = chemicalShift;
}
export { addExclusionZone, deleteExclusionZone, setMatrixGenerationOptions, toggleMatrixGenerationViewProperty, changeMatrixGenerationScale, changeMatrixGenerationStocsyChemicalShift, resetDefaultViewMatrixGenerationOptions, };
